import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Typography from 'Components/UI/Typography';
import Button from 'Components/UI/Button';
import useMobileLayout from 'Hooks/useMobileLayout';
import CalendarAlertIcon from 'Assets/Images/calendar-alert.svg';
import {
  fetchDataFromLinkQueryParam,
  setNewLinkQueryParam,
  useClientSchedulerDispatchContext,
} from 'Context/NewClientSchedulerContext';
import moment from 'moment-timezone';
import fr from 'facet-rest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: theme.palette.facet.primaryGray,
    height: '100%',
  },
  header: {
    color: theme.palette.facet.accentBlue2,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: theme.palette.common.white,
    padding: theme.spacing(8, 4, 8, 4),
  },
  desktopContainer: {
    borderRadius: theme.radius.md,
    width: '33%',
  },
  body: {
    margin: theme.spacing(2),
    textAlign: 'center',
  },
  scheduleMeetingButton: {
    marginTop: theme.spacing(1),
  },
  calendarAlertIcon: {
    marginBottom: theme.spacing(2),
  },
});

const RescheduleLinkExpired = ({ classes, className }) => {
  const { householdResource } = useSimpleHousehold();
  const dispatch = useClientSchedulerDispatchContext();

  const handleScheduleMeetingButtonClick = async () => {
    const [householdResourceWithTz] = await householdResource.link('self').get({
      params: {
        tz: moment.tz.guess(),
      },
    });
    setNewLinkQueryParam(dispatch, householdResourceWithTz.relationship(fr.relationships.currentMonthAvailabilityPeriod.name).link('related').url());
    fetchDataFromLinkQueryParam(dispatch);
  };

  const isMobile = useMobileLayout();

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classNames(classes.container, {
        [classes.desktopContainer]: !isMobile,
      })}
      >
        <img className={classes.calendarAlertIcon} src={CalendarAlertIcon} />
        <Typography variant="h2" className={classes.header}>
          Your reschedule link has expired
        </Typography>
        <Typography variant="body" className={classes.body}>
          The meeting you are trying to reschedule has already occurred or the date of the meeting has passed.
          If you&#39;d like to schedule a new meeting, please click the button below.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.scheduleMeetingButton}
          onClick={handleScheduleMeetingButtonClick}
        >
          Schedule meeting
        </Button>
      </div>
    </div>
  );
};

RescheduleLinkExpired.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

RescheduleLinkExpired.defaultProps = {
  className: '',
};

export default withStyles(styles)(RescheduleLinkExpired);
